import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostOrtKategorieCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostOrtKategorieCommandService],
  exports: []
})
export class PostOrtKategorieCommandServiceModule { }
